import { AddMemberData } from './components/AddScannerModal/types';
import { Gate } from './types';
import { api } from 'services/api';

export const getEventGates = async (eventId: string): Promise<Gate[]> => {
	const response = await api.get(`/events/${eventId}/gates`);
	return response.data;
};

export const getPartnerMembers = async (): Promise<any> => {
	const response = await api.get('/partners/settings');
	return response.data;
};

export const createEventGate = async (name: string, eventId: string): Promise<Gate> => {
	const response = await api.post(`/events/${eventId}/gates`, { name });
	return response.data;
};

export const deleteEventGate = async (eventId: string, gateId: number): Promise<void> => {
	await api.delete(`/events/${eventId}/gates/${gateId}`);
};

export const assignScanner = async (eventId: string, gateId: number, scannerId: number): Promise<void> => {
	const body = { scanner_id: scannerId };
	await api.post(`/events/${eventId}/gates/${gateId}/assign`, body);
};

export const removeScanner = async (eventId: string, gateId: number, scannerId: number): Promise<void> => {
	await api.delete(`/events/${eventId}/gates/${gateId}/unassign/${scannerId}`);
};

export const addMember = async (data: AddMemberData): Promise<void> => {
	await api.post('/members/invite', data);
};
